module.exports = __webpack_public_path__ + "assets/img/Upload Photo.11a183c7.svg";